import { useEffect, useRef } from "react";

/**
 * Renders model HTML the same way production and Feedback's TaskResultFrame
 * do: write into an iframe via doc.write (not srcDoc), inject Tailwind CDN,
 * and cap height so long results scroll inside the pane.
 */
export default function HtmlFrame({ html, title = "Result preview" }) {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    const doc = iframe && iframe.contentDocument;
    if (!doc) {
      return undefined;
    }

    const docHtml =
      '<!DOCTYPE html><html><head><meta charset="utf-8">' +
      '<script src="https://cdn.tailwindcss.com"></scr' +
      "ipt>" +
      "<style>" +
      "body{font-family:'Inter',-apple-system,'Segoe UI',Roboto,sans-serif;margin:14px;color:#0f172a;}" +
      "img{max-width:100%;height:auto;}" +
      "table{max-width:100%;}" +
      "</style></head><body>" +
      (html || "") +
      "</body></html>";

    doc.open();
    doc.write(docHtml);
    doc.close();

    const MAX_HEIGHT = 520;
    const updateHeight = () => {
      try {
        const height = doc.body && doc.body.scrollHeight;
        if (height) {
          iframe.style.height = `${Math.min(height + 24, MAX_HEIGHT)}px`;
        }
      } catch {
        // keep current height
      }
    };

    // Tailwind CDN injects styles asynchronously, so re-measure a few times.
    const timers = [150, 500, 1200, 2000].map((ms) =>
      setTimeout(updateHeight, ms),
    );

    return () => timers.forEach(clearTimeout);
  }, [html]);

  return <iframe ref={iframeRef} title={title} className="mse-html-frame" />;
}
